// extracted by mini-css-extract-plugin
export default {"flavor_option":"nM","out_of_stock_text":"oM","out_of_stock":"pM","flavor_option_image":"qM","flavor_option_info":"rM","flavor_option_title":"sM","flavor_option_limited":"tM","flavor_option_amount_wrapper":"uM","flavor_option_amount_button":"vM","zero_amount":"wM","no_flavors":"xM","no_flavors_active":"yM","flavor_option_select_wrapper":"zM","flavor_option_select_wrapper__selected":"AM"};
    if(module.hot) {
      // 1713809678753
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  